// @flow
import React from "react";
import { withGlobalContext } from "../common/GlobalContext";
import type { $Site, $Agent, $SiteOffice, $Team } from "flow/types";

type $Props = {
  site: $Site,
  agent: $Agent,
  office: $SiteOffice,
  team: $Team,
  headerNav: string,
};

const getValidUrl = (url = "") => {
  let newUrl = decodeURIComponent(url);
  newUrl = newUrl.trim().replace(/\s/g, "");

  if (/^(:\/\/)/.test(newUrl)) {
    return `http${newUrl}`;
  }
  if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
    return `http://${newUrl}`;
  }

  return newUrl;
};

const RenderLogo = ({ site, agent, team, office, headerNav }: $Props) => {
  if (
    headerNav !== "threeColumnNavBar" &&
    headerNav !== "officeLogoRightSideNavBar"
  ) {
    if (site.userId && agent && agent.picture) {
      return (
        <a href="/" title={`${agent.firstName || ""} ${agent.lastName || ""}`}>
          <img
            src={agent.picture}
            alt={`${agent.firstName || ""} ${agent.lastName || ""}`}
          />
        </a>
      );
    } else if (site.teamId && team && team.logoPath) {
      return (
        <a href="/" title={team.name}>
          <img src={team.logoPath} alt={team.name} />
        </a>
      );
    } else if (site.officeId && office) {
      return (
        <a href="/" title={office.name || ""}>
          <img src={office.logo} alt={office.name || ""} />
        </a>
      );
    }
    return null;
  } else {
    if (office && office.logo) {
      return (
        <a
          href={office.url ? getValidUrl(office.url) : "/"}
          title={office.name || ""}
        >
          <img src={office.logo} alt={office.name || ""} />
        </a>
      );
    } else if (site.userId && agent && agent.picture) {
      return (
        <a href="/" title={`${agent.firstName || ""} ${agent.lastName || ""}`}>
          <img
            src={agent.picture}
            alt={`${agent.firstName || ""} ${agent.lastName || ""}`}
          />
        </a>
      );
    } else if (site.teamId && team && team.logoPath) {
      return (
        <a href="/" title={team.name}>
          <img src={team.logoPath} alt={team.name} />
        </a>
      );
    } else {
      return null;
    }
  }
};

export default withGlobalContext(RenderLogo);
